import Head from "next/head";
import { ReactNode } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

type DefaultLayoutProps = { children: ReactNode };

export const EmptyLayout = ({ children }: DefaultLayoutProps) => {
    return (
        <>
            <Head>
                <title>Starter Kit</title>
            </Head>

            {children}

            {process.env.NODE_ENV !== "production" && <ReactQueryDevtools initialIsOpen={false} />}
        </>
    );
};
